<vue-toast icon="success">
    <span toast-body>{{toastContent}}</span>
  </vue-toast>